import React from "react";
import Modal from "react-modal";
import { Button } from "../../../common/Button/Button";
import ModalContent from "../../../common/Modal/ModalContent";
import { X } from "react-feather";
import Radio from "../../../common/Radio/Radio";
import Spinner from "../../../common/Spinner/Spinner";
import close_modal from "../../../assets/ic_close_wh.svg";

Modal.setAppElement("#root");

export default function SelectCatalogueModal({ catalogue, ...props }) {
	return (
		<Modal
			isOpen={props.isOpen}
			onRequestClose={props.toggleModal}
			ariaHideApp={false}
		>
			<ModalContent className="medium-general-modal conv-width-40%">
				<div className="modal-header">
					<span className="modal-title">Select Catalouge</span>
					<img
						alt="close"
						id="Close"
						src={close_modal}
						className="close modal-close"
						onClick={props.toggleModal}
					/>
				</div>
				<div className={`modal-body notes-trail-content conv-pl25 conv-pr25 custom-scrollbar 
					${props.isDisabled}
					${props.isLoading && "set-opacity"}`}>
					{props.isLoading && <Spinner className="center" />}
					<div className="conv-mt10">
						{catalogue.length === 0 && (
							<div>No Catalogue Available.</div>
						)}
						{catalogue.map((entry, i) => {
							const {
								fAmountFirst,
								fAmountSecond,
								fAmountFull,
								sDeliveryMode,
								sPaymentReceiver,
								sPaymentMode,
								sCalculatorRefId,
								sMode,
							} = entry;
							return (
								<div key={i}>
									<Radio
										checked={
											entry.sCatalogueId ===
											props.selectedCatalogue
										}
										name="catalogue"
										id={`_${entry.id}`}
										label={entry.sPaymentMode}
										onClick={(id) => {
											props.onCatalogueSelected(
												entry.sCatalogueId
											);
										}}
										onChange={(e) => {
											e.stopPropagation();
										}} //provide dummy onchange handler to supress warning.
									/>
									<div className="catalogue-details">
										<div className="row">
											<div className="col-12">
												Service Delivery Type:{" "}
												<b>{sDeliveryMode}</b>
											</div>
											<div className="col-12">
												Pricing and Processing Mode:{" "}
												<b>{sMode}</b>
											</div>
											<div className="col-12">
												<span>
													First Amount:{" "}
													<b>₹ {fAmountFirst}</b>
												</span>
												<span className="conv-ml10">
													Second Amount:{" "}
													<b>₹ {fAmountSecond ?? 0}</b>
												</span>
												<span className="conv-ml10">
													Full Amount: <b>₹ {fAmountFull}</b>
												</span>
											</div>
											<div className="col-12">
												<span>
													Payment Receiver:{" "}
													<b>{sPaymentReceiver}</b>
												</span>
											</div>
											<div className="col-12">
												<span>
													Payment Configuration:{" "}
													<b>{sPaymentMode}</b>
												</span>
											</div>
										</div>
									</div>
								</div>
							);
						})}
						<div className="conv-mt10">
							<button 
								type="button" 
								className={`my-services-model-submit-btn conv-pl25 conv-pr25 conv-mt10`}
								onClick={() =>props.onSaveCatalogue()}>
								Save
							</button>
							<button 
								type="button" 
								className={`my-services-model-cancel-btn conv-ml25 conv-mt10`}
								onClick={() =>props.toggleModal()}>
								Cancel
							</button>
						</div>
					</div>
				</div>
			</ModalContent>
		</Modal>
	);
}
